import ModalGeneralComponent from "./ModalGeneralComponent";
import TitleH2Component from "./TitleH2Component";
import { Fragment } from "react";
import stylebtn from "../styles/btn.module.scss";
import styleGeneral from "../styles/general.module.scss";
import TitleH4Component from "./TitleH4Component";
import ParrafoComponent from "./ParrafoComponent";
import { useFormatter } from "../hooks/useFormatter";


const ModalPendienteEntrega = (props) => {
  const {
    mensaje,
    data,
    show,
    handleClose,
    create,
    textInput,
    value,
    name,
    onChange,
    currentFactura,
  } = props;

  const { formatDate,formatDateUTC,formatHora } = useFormatter();

  const dataOrdenada = [...(data || [])].sort((a, b) => {
    const fechaA = new Date(`${a?.fechaEntrega || ""}T${a?.horaEntrega || "00:00:00"}`);
    const fechaB = new Date(`${b?.fechaEntrega || ""}T${b?.horaEntrega || "00:00:00"}`);
    return fechaB - fechaA;
  });

  return (
    <Fragment>
      {/** Modal para ver registros de pendiente de entregas*/}
      <ModalGeneralComponent
        styleGroup={`d-flex align-items-center modal-general `}
        styleTitle={"box-text color-madera fw700 roboto text-center WorkSans"}
        show={show}
        handleClose={handleClose}
      >
        <div className="container">
          <ParrafoComponent styleGroup="text-center color-danger fw400 WorkSans">
                {mensaje}
              </ParrafoComponent>
              <div className="mb-2">
                <ParrafoComponent styleGroup="box-text color-dark fw700 roboto mb-2 text-end">
                  N° Factura: {currentFactura?.numeroFactura}
                </ParrafoComponent>
                <TitleH2Component styleGroup="box-text color-dark fw700 roboto mb-2 text-center">
                  REGISTRO PRODUCTOS ENTREGADOS
                </TitleH2Component>
              </div>
              <div>
                <TitleH4Component styleGroup="box-text color-dark fw700">
                  {currentFactura?.Cliente?.Persona?.nombre}{" "}
                  {currentFactura?.Cliente?.Persona?.apellido}
                </TitleH4Component>
                <ParrafoComponent>
                  C.C. {currentFactura?.Cliente?.Persona?.cedula}
                </ParrafoComponent>
              </div>
          <div className="d-flex align-items-start justify-content-between">
            <div
              className={`table-responsive mt-4 ${styleGeneral.scrollElement} w-100`}
            >
              

              <table className="table table-bordered table-sm table-hover align-middle text-center compact-table">
                <thead className="table-light">
                  <tr>
                    <th scope="col " className="color-madera">
                      #
                    </th>
                    <th scope="col" className="color-madera">
                      Fecha
                    </th>
                    <th scope="col" className="color-madera">
                      Hora
                    </th>
                    <th scope="col" className="color-madera">
                      Cantidad
                    </th>
                    <th scope="col" className="color-madera">
                      Descripcion
                    </th>
                     <th scope="col" className="color-madera">
                      Vendedor
                    </th>
                  </tr>
                </thead>
                {dataOrdenada.length !== 0 ? (
                  <tbody>
                    {dataOrdenada?.map((item, index) => (
                      <tr key={index}>
                        <th className="text-center">{index + 1}</th>

                        <td className="text-center">{formatDateUTC(item?.fechaEntrega) || formatDate(item?.createdAt)}</td>

                        <td className="text-center">{item?.horaEntrega || formatHora(item?.createdAt) }</td>

                        <td className="text-center">{item?.cantidadEntrega}</td>

                        <td className="text-center">{item?.producto}</td>

                        <td className="text-center">{item?.vendedor}</td>
                      </tr>
                    ))}
                  </tbody>
                ) : (
                  <tbody>
                    <tr>
                      <td colSpan={6} className="text-center">
                        SIN REGISTROS
                      </td>
                    </tr>
                  </tbody>
                )}
              </table>
            </div>
          </div>
          <div className="d-flex w-100 justify-content-end aling-items-start">
            <div className=" mt-4">
              <button
                type="button"
                className={` ${stylebtn.btn_desnudo} ${stylebtn.line} p-0 me-3 `}
                onClick={handleClose}
              >
                Salir
              </button>
            </div>
          </div>
        </div>
      </ModalGeneralComponent>
    </Fragment>
  );
};

export default ModalPendienteEntrega;
